import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ArancelesService extends ApiService {
    entityType = EntityType.ARANCEL;
    url = 'api/aranceles/';
}
